/* global am4core am4maps am4charts bocAmchart4 */
/* exported am4themes_boc */

/**
 * Master color array to define series colors
 * @type {string[]}
 */
/*  eslint-disable line-comment-position */
bocAmchart4.bocColors = [
    "#67b7dc", "#fdd400", "#0eb663", "#b92020", // 0  - 3
    "#f6871e", "#a92c90", "#f089b8", "#8f7456", // 4  - 7
    "#e5c273", "#ee3344", "#0069eb", "#cb7eff", // 8  - 11
    "#006090", "#f8b79c", "#20a0a0", "#375c15", // 12 - 15
    "#b0d050", "#ff5166", "#86346a", "#897cb0", // 16 - 19
    "#a35e00", "#74b8ff", "#732eaa", "#ff7e86", // 20 - 23
    "#6f7800", "#40db47", "#4434a5", "#ffb64e", // 24 - 27
    "#059103", "#ff62dd", "#010101", "#c21d61", // 28 - 31
    "#cc6402", "#8f5468", "#194fff", "#5e88f2", // 32 - 35
    "#cd6884", "#c1876b", "#08809c", "#cc0bb2", // 36 - 39
    "#588836", "#9a0cff", "#d1361c", "#a38440", // 40 - 43
    "#9e4ab5", "#018f7c", "#9e9621", "#925ef5", // 44 - 47
    "#5e8892", "#3266ad", "#a07dff", "#fefefe"  // 48 - 51
];
/*  eslint-enable line-comment-position */

/**
 * Dark theme copy of color array to define series colors
 * @type {string[]}
 */
bocAmchart4.bocDarkColors = bocAmchart4.bocColors.slice();
// Swap the black and white for dark mode
bocAmchart4.bocDarkColors[30] = bocAmchart4.bocColors[51];
bocAmchart4.bocDarkColors[51] = bocAmchart4.bocColors[30];

/**
 * Dark theme boc function
 * @param {object} target Object to be adjusted
 * @returns {void}
 */
bocAmchart4.bocDarkTheme = function (target) {
    if (target instanceof am4core.ColorSet) {
        target.list = bocAmchart4.bocDarkColors.map(function (hexColor) {
            return am4core.color(hexColor);
        });
    }

    /** possible values for setFor
     "stroke"
     "fill"
     "primaryButton"
     "primaryButtonHover"
     "primaryButtonDown"
     "primaryButtonActive"
     "primaryButtonText"
     "primaryButtonStroke"
     "secondaryButton"
     "secondaryButtonHover"
     "secondaryButtonDown"
     "secondaryButtonActive"
     "secondaryButtonText"
     "secondaryButtonStroke"
     "grid"
     "background"
     "alternativeBackground"
     "text"
     "alternativeText"
     "disabledBackground"
     "positive"
     "negative"
     */
    if (target instanceof am4core.InterfaceColorSet) {
        // Used for most text by default
        target.setFor("text", am4core.color("#e6e6e6"));
        // Used for background of scrollbar selected area
        target.setFor("fill", am4core.color("#333333"));
        // Used for axis tooltip bg
        target.setFor("alternativeBackground", am4core.color("#232323"));
        // used for unselected graph scrollbar and tooltip background
        target.setFor("background", am4core.color("#151522"));
        // colors used for scrollbar handles in different states
        target.setFor("secondaryButton", am4core.color("#555555"));
        target.setFor("secondaryButtonHover", am4core.color("#666666"));
        target.setFor("secondaryButtonDown", am4core.color("#565656"));
        // This one is used for outline of the handles but also selected area
        target.setFor("secondaryButtonStroke", am4core.color("#787878"));
        // Color used for grid lines with some transparency applied to it
        target.setFor("grid", am4core.color("#ffffff"));
        // Used for grip lines and axis tooltip text
        target.setFor("alternativeText", am4core.color("#aaaaaa"));
        bocAmchart4.colorSet = target;
    }
};

/**
 * Theme boc function
 * @param {object} target Object to be adjusted
 * @returns {void}
 */
bocAmchart4.bocTheme = function (target) {
    if (target instanceof am4core.ColorSet) {
        //add light theme colors here
        target.list = bocAmchart4.bocColors.map(function (hexColor) {
            return am4core.color(hexColor);
        });
    }
    if (target instanceof am4core.InterfaceColorSet) {
        target.setFor("text", am4core.color("#38395a"));
        // Used for button fill
        target.setFor("secondaryButton", am4core.color("#cccccc"));
        target.setFor("secondaryButtonHover", am4core.color("#bbbbbb"));
        target.setFor("secondaryButtonDown", am4core.color("#aaaaaa"));

        // Used for grip lines
        target.setFor("alternativeText", am4core.color("#eeeeee"));
        bocAmchart4.colorSet = target;
    }
};

/**
 *
 * @param {string} theme that is handed to the function
 * @returns {undefined}
 */
bocAmchart4.setTheme = function (theme) {
    am4core.useTheme(bocAmchart4.bocTheme);
    bocAmchart4.theme = theme;
};

/**
 * Function to apply the dark theme colors
 * @param {am4core.XYChart} chart Object
 * @returns {undefined}
 */
bocAmchart4.convertToDark = function (chart) {
    if (chart.xAxes) {
        chart.xAxes.each(axis => {
            axis.renderer.labels.template.fill = am4core.color("#e6e6e6");
            axis.renderer.grid.template.stroke = am4core.color("#ffffff");
            axis.renderer.line.stroke = am4core.color("#ffffff");
            axis.renderer.ticks.template.stroke = am4core.color("#ffffff");
            axis.renderer.baseGrid.stroke = am4core.color("#ffffff");
            if (axis.title) {
                axis.title.fill = am4core.color("#e6e6e6");
            }
            axis.axisRanges.each(range => {
                range.axisFill.fill = am4core.color("#ffffff");
                range.grid.stroke = am4core.color("#ffffff");
            });
        });
    }
    if (chart.yAxes) {
        chart.yAxes.each(axis => {
            axis.renderer.labels.template.fill = am4core.color("#e6e6e6");
            axis.renderer.grid.template.stroke = am4core.color("#ffffff");
            axis.renderer.line.stroke = am4core.color("#ffffff");
            axis.renderer.ticks.template.stroke = am4core.color("#ffffff");
            axis.renderer.baseGrid.stroke = am4core.color("#ffffff");

            if (axis.title) {
                axis.title.fill = am4core.color("#e6e6e6");
            }
            axis.axisRanges.each(range => {
                range.axisFill.fill = am4core.color("#ffffff");
                range.grid.stroke = am4core.color("#ffffff");
            });
        });
    }

    // Scrollbar is added later, so need to delay this
    chart.events.on("validated", function() {
        if (chart.scrollbarX) {
            let scrollbar = chart.scrollbarX;
            scrollbar.background.fill = am4core.color("#333333");

            scrollbar.children.each((child) => {
                if (child.className === "Sprite") {
                    child.fill = am4core.color("#232323");
                }
            });

            let elements = [scrollbar.thumb, scrollbar.startGrip, scrollbar.endGrip];
            elements.forEach((element) => {
                if (element && element.background) {
                    element.background.fill = am4core.color("#555555");
                    element.background.stroke = am4core.color("#787878");
                    if (element.children && element.children.length > 0) {
                        element.children.each(child => {
                            child.stroke = am4core.color("#aaaaaa");
                        });
                    }

                    let hoverState = element.background.states.create("hover");
                    hoverState.properties.fill = am4core.color("#666666");

                    let downState = element.background.states.create("down");
                    downState.properties.fill = am4core.color("#565656");
                }
            });
        }
    });

    if (chart.legend) {
        chart.legend.labels.template.fill = am4core.color("#e6e6e6");
        chart.legend.labels.each(function (label) {
            let state = label.states.getKey("default");
            if (state) {
                state.properties.fill = am4core.color("#e6e6e6");
            }
        });
        
        // Handle value labels (period values, etc.)
        if (chart.legend.valueLabels) {
            chart.legend.valueLabels.template.fill = am4core.color("#e6e6e6");
            chart.legend.valueLabels.each(function (valueLabel) {
                let state = valueLabel.states.getKey("default");
                if (state) {
                    state.properties.fill = am4core.color("#e6e6e6");
                }
            });
        }
    }

    if (chart.title && chart.title.children) {
        for (let idx = 0; idx < chart.title.children.length; idx++) {
            chart.title.children.getIndex(idx).fill = am4core.color("#e6e6e6");
        }
    }

    if (chart.notes && chart.notes.children) {
        for (let idx = 0; idx < chart.notes.children.length; idx++) {
            chart.notes.children.getIndex(idx).fill = am4core.color("#e6e6e6");
        }
    }

    chart.children.each(child => {
        if (child instanceof am4core.Label) {
            child.fill = am4core.color("#e6e6e6");
        }
    });

    if (chart.bottomAxesContainer && chart.bottomAxesContainer.children) {
        let labelsContainer = chart.bottomAxesContainer.children.length > 2
            ? chart.bottomAxesContainer.children.getIndex(2)
            : null;

        if (labelsContainer?.children?.length) {
            labelsContainer.children.each(child => {
                if (child instanceof am4core.Label) {
                    child.fill = am4core.color("#e6e6e6");
                }
            });
        }
    }

    // Handle pie chart series labels
    if (chart.series && chart.series.length > 0) {
        chart.series.each(series => {
            if (series.labels && series.labels.template) {
                series.labels.template.fill = am4core.color("#e6e6e6");
            }
            if (series.ticks && series.ticks.template) {
                series.ticks.template.stroke = am4core.color("#e6e6e6");
            }
        });
    }

    let series = chart.series.getIndex(0);
    if (typeof am4maps !== 'undefined' && series instanceof am4maps.MapPolygonSeries) {
        if (series.mapPolygons?.template) {
            series.mapPolygons.template.applyOnClones = true;
            series.mapPolygons.template.stroke = am4core.color("#888888");
        }
    }

    if (bocAmchart4.vars[chart.bocSettings.id].hasOwnProperty('blendColor')) {
        bocAmchart4.vars[chart.bocSettings.id].blendColor.forEach((item, idx) => {
            // console.log(`Index: ${idx}, Color: ${item.color}`);
            chart.series.getIndex(idx).fill = bocAmchart4.invertAmChartColor(item.color);
        });
    }

    bocAmchart4.updateSeriesColors(chart, '#010101', '#ffffff');
    bocAmchart4.updateSeriesColors(chart, '#fefefe', '#000000');
    bocAmchart4.updateSeriesColors(chart, "#38395a", "#e6e6e6");
};

bocAmchart4.updateSeriesColors = function (chart, oldColor, newColor) {
    // console.log("----------------" + oldColor + "----------------")
    chart.series.each(series => {
        series.tooltip.background.fill = am4core.color("black");
        series.tooltip.label.fill = am4core.color("white");

        if (series instanceof am4charts.LineSeries) {
            bocAmchart4.updateObjectColors(series, oldColor, newColor);
            // console.log("Line series")
            if (series.bullets) {
                series.bullets.each(bullet => {
                    // console.log('>>> ' + bullet.className);
                    bocAmchart4.updateObjectColors(bullet, oldColor, newColor);
                    bullet.children.each(child => {
                        // console.log('>>>>>> ' + child.className);
                        bocAmchart4.updateObjectColors(child, oldColor, newColor);
                    });
                });
            }
        } else if (series instanceof am4charts.ColumnSeries) {
            // console.log("Column series")
            if (series.columns) {
                series.columns.each(column => {
                    // console.log('>>> ' + column.className);
                    bocAmchart4.updateObjectColors(column, oldColor, newColor);
                    if (column.children && column.children.length > 0) {
                        column.children.each(child => {
                            // console.log('>>>>>> ' + child.className);
                            if (child instanceof am4core.Label) {
                                if (chart.bocSettings.args.showcolumnlabels === 'top') {
                                    child.fill = am4core.color("#e6e6e6");
                                }
                            }
                        });
                    }
                });
            }
            // Update the legend marker color
            if (series.legendDataItem?.marker?.children?.length > 0) {
                let markerChild = series.legendDataItem.marker.children.getIndex(0);
                bocAmchart4.updateObjectColors(markerChild, oldColor, newColor);
                series.legendDataItem.marker.invalidate();
            }
        } else if (series instanceof am4charts.XYSeries) {
            if (series.bulletsContainer) {
                if (series.bulletsContainer.children && series.bulletsContainer.children.length > 0) {
                    // console.log("Bulletcontainer has children: ", series.bulletsContainer.children.length);
                    series.bulletsContainer.children.each(child => {
                        bocAmchart4.updateObjectColors(child, oldColor, newColor);
                        // console.log('>>>>>> ' + child.className);
                        if (child.children && child.children.length > 0) {
                            child.children.each(grandchild => {
                                // console.log('>>>>>> ' + grandchild.className);
                                if (grandchild instanceof am4core.Label) {
                                    grandchild.fill = am4core.color("#e6e6e6");
                                }
                            });
                        }
                    });
                }
            }
        }
    });
};

bocAmchart4.updateObjectColors = function (object, oldColor, newColor) {
    if (object && object.stroke && object.stroke.toString() === oldColor) {
        // console.log("Updating object stroke", object.className);
        object.applyOnClones = true;
        object.stroke = am4core.color(newColor);
    }
    if (object.fill && object.fill.toString() === oldColor) {
        // console.log("Updating object fill", object.className);
        object.applyOnClones = true;
        object.fill = am4core.color(newColor);
    }
};

bocAmchart4.invertAmChartColor = function (amColor) {
    const rgb = amColor.rgb;
    const invertedR = 255 - rgb.r;
    const invertedG = 255 - rgb.g;
    const invertedB = 255 - rgb.b;

    return am4core.color(`rgb(${invertedR}, ${invertedG}, ${invertedB})`);
};
